export function logoutPath() {
  return '/logout'
}
